module.exports = __webpack_public_path__ + "static/media/SPRINGTER _VIDEO_FOTOS_SIN TEXTOS_1920x1080_FINAL.cbe31f0.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/media/SPRINGTER _VIDEO_FOTOS_SIN TEXTOS_1920x1080_FINAL.mp4
// module id = XV/6
// module chunks = 1